import React from 'react';
import PublicStaticPage from './PublicStaticPage';

const Cookies = () => <PublicStaticPage pageKey="cookies" />;

export default Cookies;
